import { api } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type {
  EarlyAccessRequestInput,
  EarlyAccessRequestResponse,
} from '../models/early-access.types';

export function submitEarlyAccessRequest(
  input: EarlyAccessRequestInput,
): Promise<EarlyAccessRequestResponse> {
  return api().post<EarlyAccessRequestResponse>(
    ENDPOINTS.earlyAccess.requests,
    input,
    { skipAuth: true, skipRefresh: true },
  );
}
